import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px;
  margin-top: -32px;
  border-radius: 32px 32px 0 0;
  z-index: 1;

  .steps {
    padding: 0;
    margin: 0 0 30px;
    list-style: none;

    &__item {
      border-radius: 16px;
      background-color: ${rgba(WHITE, 0.1)};
      padding: 32px 24px 24px;
      display: flex;
      align-items: center;

      &:not(:last-of-type) {
        margin-bottom: 24px;
      }
    }

    &__number {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      height: 48px;
      width: 48px;
      border-radius: 50%;
      margin-right: 28px;
      background-color: ${rgba(WHITE, 0.2)};
      font-weight: bold;
    }

    &__text {
      span {
        text-decoration: underline;
      }
    }
  }

  ${breakpoints.down('xs')} {
    padding-top: 40px;
    padding-bottom: 40px;

    .steps {
      &__item {
        padding: 12px;
      }
    }
  }
`;

export default Container;
